import React from 'react';
import { Plus } from 'lucide-react';
import { IconButton } from '../UI';

interface StringListEditorProps {
  label: string;
  values: string[];
  onChange: (next: string[]) => void;
}

const StringListEditor: React.FC<StringListEditorProps> = ({ label, values, onChange }) => {
  const update = (index: number, value: string) => {
    const next = [...values];
    next[index] = value;
    onChange(next);
  };

  const remove = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  const add = () => {
    onChange([...values, '']);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="space-y-2">
        {values.map((value, index) => (
          <div key={index} className="flex items-center gap-2">
            <input
              type="text"
              value={value}
              onChange={(e) => update(index, e.target.value)}
              className="field flex-1"
            />
            <IconButton action="remove" onClick={() => remove(index)} />
          </div>
        ))}
        <button
          type="button"
          onClick={add}
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-800 font-medium"
        >
          <Plus className="w-4 h-4" /> Adicionar
        </button>
      </div>
    </div>
  );
};

export default StringListEditor;
